import { useEffect } from 'react';

const set = (selector, attr, value) => {
  if (!value) return;
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/** Keeps <title>, description, OG tags and canonical in sync per route. */
export default function usePageMeta({ title, description, path, image }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      set('meta[property="og:title"]', 'content', title);
    }
    if (description) {
      set('meta[name="description"]', 'content', description);
      set('meta[property="og:description"]', 'content', description);
    }
    if (image) set('meta[property="og:image"]', 'content', image);
    if (path) upsertLink('canonical', window.location.origin + path);
  }, [title, description, path, image]);
}
